(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    if (window.__raOrbeSelectorInit) {
      return;
    }

    window.__raOrbeSelectorInit = true;

    const openOrbe = (attempt = 0) => {
      if (typeof window.mdApp_openAndRefreshModal === 'function') {
        window.mdApp_openAndRefreshModal();
        return;
      }

      if (attempt < 20) {
        window.setTimeout(() => openOrbe(attempt + 1), 150);
      }
    };

    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-ra-orbe-open]');

      if (!trigger) {
        return;
      }

      event.preventDefault();
      openOrbe();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
